import styled from 'styled-components';

export const StyledFooter = styled.div`
  display: flex;
  justify-content: space-between;
`;
